import {useEffect} from 'react';
import {atom, useAtom} from 'jotai';
import {usePathname} from 'next/navigation';

export const historyAtom = atom<string[]>([]);

const useRouteTracker = () => {
  const pathname = usePathname();
  const [history, setHistory] = useAtom(historyAtom);

  useEffect(() => {
    setHistory([...history.slice(-9), pathname]);
  }, [pathname]);
};

export default useRouteTracker;
